import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './TextEditorToolEditableValue.scss';

class TextEditorToolEditableValue extends Component {
  static propTypes = {
    value: PropTypes.number,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onToggle: PropTypes.func.isRequired,
  };

  state = {
    value: this.props.value,
  };

  handleInputChange = e => {
    this.setState({ value: e.target.value });
  };

  handleKeyPress = e => {
    const { value } = this.state;
    const { maxValue, minValue } = this.props;

    if (e.key !== 'Enter') {
      return;
    }

    if (maxValue && parseInt(value) > parseInt(maxValue)) {
      this.changeValue(maxValue);
      return;
    }

    if (minValue && parseInt(value) < parseInt(minValue)) {
      this.changeValue(minValue);
      return;
    }

    this.changeValue(value);
  };

  changeValue = value => {
    const { onChange, onToggle } = this.props;

    onToggle();

    if (value) {
      onChange(value);
    }
  };

  componentDidMount = () => {
    this.el.select();
  };

  saveRef = el => {
    this.el = el;
  };

  render = () => {
    const { value } = this.state;

    return (
      <input
        ref={this.saveRef}
        className={styles.editableValue}
        value={value}
        onChange={this.handleInputChange}
        onKeyPress={this.handleKeyPress}
      />
    );
  };
}

export default TextEditorToolEditableValue;
